export default "__VITE_ASSET__CSV1mBQH__"